import { render, staticRenderFns } from "./SupportRequestCard.vue?vue&type=template&id=4fdbd5be"
import script from "./SupportRequestCard.vue?vue&type=script&lang=js"
export * from "./SupportRequestCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports